import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import Image from 'next/image';
import React from 'react';
import { useTranslation } from 'next-i18next';
import StoreLinkAlt from '../StoreLink';

const FeaturesCTA = () => {
  const { t } = useTranslation(`features`);

  return (
    <section className="boxed-container">
      <Flex
        mb={[`250px`, null, null, 0]}
        direction={[`column`, null, null, `row`]}
        minH={425}
        justify="center"
        align="center"
        color="white"
        mx="auto"
        w="full"
        bgColor="#74c4cb"
        borderRadius="4rem"
        position="relative"
      >
        <Flex
          direction="column"
          py={[12, null, null, 24]}
          px={[8, null, null, 20]}
        >
          <Heading color="white" as="h3" size="2xl" mb={8}>
            {t(`call_to_action.title`)}
          </Heading>
          <Text mb={12} lineHeight="2">
            {t(`call_to_action.description`)}
          </Text>
          <Flex direction={[`column`, null, `row`]} justify="start">
            <StoreLinkAlt
              href="https://apps.apple.com/tr/app/voltran-app/id1567581311"
              type="ios"
            />
            <StoreLinkAlt
              mt={[2, null, 0]}
              href="https://play.google.com/store/apps/details?id=com.voltran.app.voltran"
              type="android"
            />
          </Flex>
        </Flex>
        <Box h={[130, 270, null, 0]} w={[0, null, null, 562]} />
        <Box
          position={[`absolute`, null, null, `absolute`]}
          transform={[`translateY(30%)`, null, null, `none`]}
          right={[null, null, null, 0]}
          bottom={[-110, null, null, `-80px`]}
          w={[`260px`, `auto`]}
        >
          <Image
            alt="download now"
            width={415}
            height={562}
            src="/images/features/cta.png"
          />
        </Box>
      </Flex>
    </section>
  );
};

export default FeaturesCTA;
